import RupeeIcon from "../../../assets/icons/pay-method-icons/rupee-icon";
import formatCurrency from "./format-currency";
import ProgressBar from "./progress-bar";

const Component1 = ({
  value,
  transactions,
  vendorValue,
  vendorPercent,
  customerValue,
  customerPercent,
  progressPercent,
}) => {
  return (
    <div className="w-full h-[160px] bg-[var(--list-payMet-card-bg)] p-[12px] rounded-[12px] flex flex-col  ">
      <div className="flex justify-between">
        <label className="font-[var(--trans-stats-con-value-fw)] text-[length:var(--trans-stats-con-value1-fs)] leading-4 align-middle text-[var(--bill-list-payMet-desc-fg)] mb-[8px]">
          Total Payment
        </label>
        <RupeeIcon />
      </div>
      <div className="flex space-x-[4px] mb-[20px]">
        <label className="font-[var(--trans-stats-con-label1-fw)] text-[length:var(--trans-stats-con-label1-fs)] leading-6 align-middle ">
          {formatCurrency(value)}
        </label>
        <label className="font-[var(--trans-stats-con-value-fw)] text-[length:var(--trans-stats-con-label-fs)] leading-6 align-middle text-[var(--trans-stats-con-blue-fg)]">
          {transactions} Transactions
        </label>
      </div>
      <div className="flex flex-row justify-between">
        <div className="flex flex-col  space-y-[4px]  text-[length:var(--trans-stats-con-label-fs)] leading-[16px] font-[var(--trans-stats-con-value-fw)]">
          <label className="  align-middle">Vendor</label>
          <label>
            <span className="opacity-40"> {formatCurrency(vendorValue)}</span>{" "}
            <span className="text-[var(--trans-stats-con-blue-fg)]">
              ({vendorPercent}%)
            </span>
          </label>
        </div>
        <div className="flex flex-col  space-y-[4px]  text-[length:var(--trans-stats-con-label-fs)] leading-[16px] font-[var(--trans-stats-con-value-fw)]">
          <label className="  align-middle">Customer</label>
          <label>
            <span className="opacity-40"> {formatCurrency(customerValue)}</span>{" "}
            <span className="text-[var(--trans-stats-con-blue-fg)]">
              ({customerPercent}%)
            </span>
          </label>
        </div>
      </div>
      <ProgressBar
        value={progressPercent}
        progressColor={"#3B82F6"}
        bgColor={"#37C195"}
        divClass="mb-[20px] mt-[4px]"
      />
    </div>
  );
};
export default Component1;
